export class DeliveryMethod {
  public id?: string;
  public name: string;
}
